export default "__VITE_ASSET__040ab6dc__"